<template>
    <div>
        <div v-if="!editing" :class="reactiveClass">
            <div v-if="client.touchy_edit">
                <b-link title="Cliquer pour modifier" @click="edit">
                    <span v-if="form.balance_priority > 0">{{
                        form.balance_priority
                    }}</span>
                    <span v-else>-</span>
                </b-link>
            </div>
            <div v-else>
                <b-link
                    title="Seuls l'expert comptable, le manager ou le superviseur peuvent modifier la priorité"
                    class="not-allowed"
                >
                    <span v-if="form.balance_priority > 0">{{
                        form.balance_priority
                    }}</span>
                    <span v-else>-</span>
                </b-link>
            </div>
        </div>
        <div v-if="editing">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-select
                    v-model="form.balance_priority"
                    size="sm"
                    :options="options"
                    @change="update"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'TablePriorityHandler',

    mixins: [TableFormHandler],

    props: {
        client: null,
    },

    data() {
        return {
            editing: false,
            displayedIcon: '',
            form: {},
            options: [
                { value: 0, text: '-' },
                { value: 1, text: '1' },
                { value: 2, text: '2' },
                { value: 3, text: '3' },
                { value: 4, text: '4' },
            ],
        }
    },

    created() {
        this.initForm()
        this.setIcon()
    },

    methods: {
        initForm() {
            this.form.balance_priority = this.client.balance_priority
        },

        edit() {
            this.editing = true
        },

        display() {
            this.editing = false
        },

        async update() {
            try {
                await axios.put(
                    `/clients/${this.client.id}/balance-priority`,
                    this.form
                )
                this.handleSuccess()
                this.setIcon()
                this.display()
                this.$emit('priority-is-updated', {
                    client: this.client.id,
                    priority: this.form.balance_priority,
                })
            } catch (error) {
                this.initForm()
                this.display()
                this.handleError()
                console.log(error)
            }
        },

        setIcon() {
            if (this.form.balance_priority > 0) {
                this.displayedIcon = `fas fa-fw fa-signal-${this.form.balance_priority}`
            }
        },
    },
}
</script>

<style scoped>
.not-allowed {
    cursor: not-allowed;
}
</style>
